import script from "./DragDrop.vue?vue&type=script&setup=true&lang=js"
export * from "./DragDrop.vue?vue&type=script&setup=true&lang=js"

import "./DragDrop.vue?vue&type=style&index=0&id=314a27bd&lang=scss"

const __exports__ = script;

export default __exports__